module.exports = __webpack_public_path__ + "static/sanofi-second-logo-en-7138381a226176edc5e7439d26244d53.png";